import {
  Component,
  Input,
} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
} from '@angular/forms';
import { CustomSelectOption } from 'src/app/core/interfaces/custom-select-option';
import { Commodity } from 'src/app/core/models/commodity';
import { CommodityService } from 'src/app/core/services/general/commodity.service';

@Component({
  selector: 'app-commodity-input',
  templateUrl: './commodity-input.component.html',
  styleUrls: ['./commodity-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: CommodityInputComponent,
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: CommodityInputComponent,
    },
  ],
})
export class CommodityInputComponent {
  @Input()
  title = "Select Commodity...";

  @Input()
  isDisabled = false;

  public value?: string;
  public localValue?: CustomSelectOption;

  public commoditiesList: Array<CustomSelectOption> = [];

  constructor(
    private commodityService: CommodityService,
  ) {
    this.commodityService
      .all()
      .subscribe((res: Array<Commodity>) => {
        this.commoditiesList = res.map((el) => {
          return {
            name: `${el.name}`,
            value: el.uuid,
          }
        });
        this.writeValue(this.value);
      });
  }

  ngOnInit(): void {
  }

  onChange = (val: string | undefined) => {
  };

  onTouched = () => { };

  touched = false;
  disabled = false;

  writeValue(val?: string) {
    this.value = val;
    if (this.value != undefined || this.value != null) {
      this.localValue = this.commoditiesList.filter((el) => el.value == val)[0];
    }
  }

  onValueChange(val?: CustomSelectOption) {
    this.value = val?.value;
    this.onChange(this.value);
    this.writeValue(this.value);
  }


  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return null;
  }
}
